import Multiselect from 'vue-multiselect';

import overviewAdd from '@/components/overview/add/index.vue';
import overiewItem from '@/components/overview/item/index.vue';
import preloader from '@/components/preloader/index.vue';
import empty from '@/components/emptyContainer/index.vue';
import pagination from '@/components/paginationSimple/index.vue';

import helpers from '@/mixins/helpers';

import Api from '@/utils/api';

export default {
  components: {
    Multiselect,
    overviewAdd,
    overiewItem,
    preloader,
    empty,
    pagination,
  },
  mixins: [
    helpers.general,
  ],
  data () {
    return {
      overviewGroup: [],
      name: '',
      typeHolder: 'Share',
      changeId: null,
      managerId: null,
      shareLink: '',
      shareGroupId: null,
      nameUser: [],
      listUser: [],
      copy: false,
      load: true,
      sortField: 'Date',
      sortDirection: 'desc',
      responseData: [],
      popupPlaceholder: '',
      params: {
        page: 1,
        ppage: 5,
        sortField: 'Date',
        sortDirection: 'desc',
      },
    };
  },
  watch: {
    params: {
      deep: true,
      handler () {
        this.getOverviewGroups();
      },
    },
  },
  computed: {
    copyTitle () {
      return this.copy === false ? 'Copy the link' : 'Copied to clipboard';
    },
    overviewAdd () {
      return this.checkPermissions('overview', 'overview-add');
    },
  },
  created () {
    this.getOverviewGroups();
  },
  methods: {
    copyLink () {
      this.copy = true;
      navigator.clipboard.writeText(this.shareLink);
    },
    getOverviewGroups () {
      this.load = true;
      this.transformParams();

      const params = {
        ...this.params,
        sortField: this.sortField,
        sortDirection: this.sortDirection,
      };

      Api.overviews
        .getGroups(params)
        .then((data) => {
          if (data.data.Status) {
            this.responseData = data.data;
            this.overviewGroup = data.data.Data;
          }

          this.load = false;
        });
    },
    transformParams () {
      if (this.sortField) { this.params.sortField = this.sortField; }

      if (this.sortDirection) { this.params.sortDirection = this.sortDirection; }
    },
    /**
         * Show popup
         *
         * @param {String} type
         * @param {Number} id
         * @param {String} name
         */
    showPopupOverviewGroup (type, id, name) {
      this.typeHolder = type;
      this.changeId = id;
      this.name = name;
      this.$modal.show('group');
      if (type == 'Create') {
        this.popupPlaceholder = 'Enter the name of the new widget';
      }
      if (type == 'Copy') {
        this.popupPlaceholder = 'Enter widget name';
      }
    },

    /**
         * Method for show popup share
         *
         * @param {Number} groupId
         */
    showPopupShare (type, groupId) {
      this.typeHolder = type;
      this.shareLink = window.location.href + '/' + groupId + '/tile';
      this.shareGroupId = groupId;
      this.$modal.show('share');
      this.popupPlaceholder = 'Select share group';
    },
    holderOverviewGroups () {
      return this.typeHolder === 'Create' ? this.createOverviewGroups()
        : this.typeHolder === 'Copy' ? this.copyOverviewGroups()
          : this.editOverviewGroups();
    },
    createOverviewGroups () {
      const params = {
        name: this.name,
      };

      this.popupPlaceholder = 'enter the name of the new widget';

      Api.overviews
        .createGroups(params)
        .then((data) => {
          if (data.data.Status) {
            this.getOverviewGroups();

            this.name = '';

            this.$root.$emit('notification', {
              message: 'Groups was created!',
              type: 'info',
              show: true,
            });
          } else {
            this.$root.$emit('notification', {
              message: data.data.Message,
              type: 'error',
              show: true,
            });
          }
          this.$modal.hide('group');
        });
    },
    editOverviewGroups () {
      const params = {
        'ID': this.changeId,
        'Name': this.name,
      };

      Api.overviews
        .editGroups(params)
        .then((data) => {
          if (data.data.Status) {
            this.getOverviewGroups();

            this.name = '';

            this.$root.$emit('notification', {
              message: 'Groups was created!',
              type: 'info',
              show: true,
            });
          } else {
            this.$root.$emit('notification', {
              message: data.data.Message,
              type: 'error',
              show: true,
            });
          }

          this.$modal.hide('group');
        });
    },
    copyOverviewGroups () {
      const params = {
        'ID': this.changeId,
        'Name': this.name,
      };

      Api.overviews
        .cloneGroups(params)
        .then((data) => {
          if (data.data.Status) {
            this.getOverviewGroups();
            this.name = '';

            this.$root.$emit('notification', {
              message: 'Groups was created!',
              type: 'info',
              show: true,
            });
          } else {
            this.$root.$emit('notification', {
              message: data.data.Message,
              type: 'error',
              show: true,
            });
          }

          this.$modal.hide('group');
        });
    },
    shareOverviewGroups () {
      const managerId = this.nameUser.map((item) => item.ID).join('|');

      const params = {
        ManagerIDs: managerId,
        OverviewGroupID: this.shareGroupId,
        Url: this.shareLink,
      };

      Api.overviews
        .shareGroups(params)
        .then((data) => {
          if (data.data.Status) {
            this.$root.$emit('notification', {
              message: 'You share overview groups!',
              type: 'info',
              show: true,
            });
          } else {
            this.$root.$emit('notification', {
              message: data.data.Message,
              type: 'error',
              show: true,
            });
          }

          this.$modal.hide('share');
        });
    },

    /**
         * Get user on name
         *
         * @param {String} name
         */
    searchName (name) {
      if (name.length < 3) {
        return;
      }

      Api.user
        .search(name)
        .then((data) => {
          if (data.data.Status) {
            this.listUser = data.data.Data;
          }
        });
    },

    sortingColumns (nameSort) {
      this.sortField = nameSort;
      if (this.sortDirection === '') {
        this.sortDirection = 'asc';
      } else if (this.sortDirection === 'asc') {
        this.sortDirection = 'desc';
      } else if (this.sortDirection === 'desc') {
        this.sortDirection = 'asc';
      }
      this.getOverviewGroups();
    },
    getAll (pages, toggle) {
      if (toggle) {
        this.params.ppage = pages;
        this.params.page = 1;
      } else {
        this.params.ppage = 5;
      }
      this.getOverviewGroups();
    },
    sendPage (page) {
      this.params.page = page;
      this.getOverviewGroups();
    },
  },
};
